/** Dev mock only — non-empty permissions so login can reach / when auth2 returns []. */
export const MOCK_OFFICE365_USER_PERMISSIONS: string[] = ['life-science-service-cloud:access'];
